import React from 'react'
import { Card, List, Grid, Icon } from 'semantic-ui-react';
import Labels from './../../../../../common/Labels';
import EllipsisTooltip from './../../../../../common/EllipsisTooltip';
import ActivityUserInfo from './../ActivityUserInfo';
import dummyImage1 from '../../../../../../images/dummy-cards/content/01.png'
import dummyImage2 from '../../../../../../images/dummy-cards/content/02.png'
import dummyImage3 from '../../../../../../images/dummy-cards/content/03.png'
import dummyImage4 from '../../../../../../images/dummy-cards/content/04.png'
import dummyImage5 from '../../../../../../images/dummy-cards/content/05.png'
import dummyImage6 from '../../../../../../images/dummy-cards/content/06.png'
import { dispatch } from '@rematch/core';
import contentURL from '../../../../../../helpers/contentURL';
var moment = require('moment');
class ContentCard extends React.Component {

    async goToContent(e, id, data) {
        e.preventDefault()
        e.stopPropagation()
        console.log("Content Card")
        await dispatch.home.redirectFromEventStream(true);
        let pLoad = {
            id: id,
            data: data
        }
        await dispatch.content.isContentAvailable(pLoad);
    }

    render() {
        const { data, selectedOrganisation, selectedAccount } = this.props;


        let currentDate = moment().format('YYYY-MM-DD');
        var initiativeEndDate = moment(data.entityData.endDate, "YYYY-MM-DD");
        let isInitiativeEndDelayed = moment.duration(initiativeEndDate.diff(currentDate)).asDays();



        return (
            <div className="StreamActivity" >
                {data.from ?
                    <ActivityUserInfo
                        user={data.from}
                        date={data.createdAt}
                        subCategory={data.subCategory}
                        data={data}
                        selectedAccount={selectedAccount}
                        selectedOrganisation={selectedOrganisation}
                    /> : ''}
                <div className="ActivityStreamContent" >
                    <div className="streamCard"
                        onClick={(e) => this.goToContent(e, data.entityId, data.entityData)}
                    >
                        <div className="imageBlock">
                            <Card className="appDefaultCard ">
                                <Card.Header>
                                    <EllipsisTooltip
                                        name={data.entityData.name}
                                    />
                                </Card.Header>
                                <Card.Content >
                                    <img className="fitImage" src={data.entityData.picture ? data.entityData.picture :
                                        data.entityData.type === 'Image' ? dummyImage1 :
                                            data.entityData.type === 'Video' ? dummyImage2 :
                                                data.entityData.type === 'Document' ? dummyImage3 :
                                                    data.entityData.type === 'Audio' ? dummyImage4 :
                                                        data.entityData.type === 'Link' ? dummyImage5 :
                                                            data.entityData.type === 'Tool' ? dummyImage6 :
                                                                dummyImage6} alt='' />
                                    {data.entityData.status === "in_development" ?
                                        <div className="badge badgeIndesign">In Design </div>
                                        : data.entityData.status === 'under_review' ? <div className="badge badgeInReview">Review request </div>
                                            : data.entityData.status === 'approved' ? <div className="badge badgeApproved">Approved </div>
                                                : data.entityData.status === 'rejected' ? <div className="badge badgeRejected">Rejected </div>
                                                    : data.entityData.status === 'published' ? <div className="badge badgePublished">Published </div>
                                                        : data.entityData.status === 'deprecated' ? <div className="badge badgeDepricated">Inactive </div>
                                                            : data.entityData.status === 'cloned' ? <div className="badge badgeCloned">Cloned / Purchased </div>
                                                                : ''}

                                    <div className="badgeRight">
                                        <span className={`badgeblock ${data.entityData.scope === 'Public' ? 'badgeRightPublic' : ''} ${data.entityData.scope === 'Private' ? 'badgeRightPrivate' : ''}`}>
                                            {data.entityData.scope === "Private" ? "Workspace" : data.entityData.scope}
                                        </span>
                                    </div>
                                </Card.Content>
                            </Card>
                        </div>
                        <div className="contentBlock" >
                            <Grid columns='equal'>

                                <Grid.Row>
                                    <Grid.Column >
                                        <Labels
                                            name="Knowledge bank"
                                            text={<EllipsisTooltip name={data.entityData.baseCategory} />} />
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Labels
                                            name="Category"
                                            text={<EllipsisTooltip name={data.entityData.category} />} />
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Labels
                                            name="Sub Category " text={
                                                <EllipsisTooltip name={data.entityData.subCategory} />
                                            } />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column onClick={(e) => e.preventDefault()}>
                                        {contentURL(data.entityData.contentpath, data.entityData.type)}<br /><br />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column >
                                        <Labels
                                            name="Description"
                                            text={<EllipsisTooltip name={data.entityData.description}
                                                line={2}
                                                position="right center"
                                                ReadMore={true}
                                                htmlView={true}
                                                stripHtml={true}
                                            />}
                                        />
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default ContentCard;